// Colour-contrast helpers for the venue theme, pure + unit-tested, and the
// SINGLE implementation used by both theme appliers (lib/venue.ts document
// theme + venue-app-shell.tsx CSS vars) so they can't drift.

/** Perceived-luminance lightness test (BT.601 weights). Non-hex → false. */
export function isLightColor(hex: string): boolean {
  const m = hex.replace(/^#/, "");
  if (m.length !== 6) return false;
  const r = parseInt(m.slice(0, 2), 16);
  const g = parseInt(m.slice(2, 4), 16);
  const b = parseInt(m.slice(4, 6), 16);
  return (0.299 * r + 0.587 * g + 0.114 * b) / 255 > 0.5;
}

/**
 * The text colour to use ON the accent (buttons/pills). Venues often set
 * `textColor` as their BODY text colour, which can sit on the same luminance
 * side as the accent (e.g. The Certs: #111 text + #111 accent), that painted
 * black-on-black buttons. CONTRAST GUARD: honour textColor only when it
 * contrasts the accent; otherwise derive from the accent's own luminance.
 */
export function accentForegroundFor(
  accentColor: string | null | undefined,
  textColor: string | null | undefined,
): string {
  const accentIsLight = accentColor ? isLightColor(accentColor) : false;
  const derived = accentIsLight ? "#000000" : "#FFFFFF";
  return textColor && isLightColor(textColor) !== accentIsLight ? textColor : derived;
}
